/** @format */

import React from "react";
import PrivateRoutes from "../Routes/PrivateRoutes";
import PublicRoutes from "../Routes/PublicRoutes";
import { useAuth } from "../Hooks/Auth";

const App = () => {
  const { check } = useAuth();
  return check() ? <PrivateRoutes /> : <PublicRoutes />;
};

export default App;
